import { Redirect, Route, useHistory } from "react-router-dom";
import loginHelper from './Common/loginHelper';

const {config} = require("./config");
const PrivateRoute = ({children, ...rest}) => {
  const userLoggedIn = loginHelper.getLoginUser();
  const history = useHistory();
  const urlRedirectUser = () => {
    history.push("/Dashboard");
  };

  const getPathName = () => {
    const splitPath = window.location.pathname.split("/");
    return splitPath[1];
  }
  const renderContent = ({ currentLocation }) => {
    if (!userLoggedIn) {
      return (
              <Redirect
                      to={{
                        pathname: "/Home",
                        state: {
                          from: currentLocation,
                          privateRoute: true,
                        },
                      }}
              />
      );
    }

    const { isAdminPage, isGlobalPage, scheme, futureRelease } = children.props;
    const isUserAdmin = userLoggedIn.CorppassRole === "Admin";
    const userSchemes = userLoggedIn.Schemes || [];
    const isForeignCompany = userLoggedIn.UENType === "NON-UEN"
    const isForeignCompanyTransfer = userLoggedIn.IsTransferHistoryExist

    /**
     * IsAllowPage -> Current Logic for page accessibility
     * isBlockForeignCompany -> if company is foreign company and have been transfer to local
     */
    const isAllowedPage =
            (!isAdminPage || (isAdminPage && isUserAdmin) || isGlobalPage) &&
            (userSchemes.includes(scheme) || scheme === "none");
    const isBlockForeignCompany = (isForeignCompany && isForeignCompanyTransfer);
    const isPathDashBoard = getPathName().localeCompare("Dashboard", undefined, {sensitivity: 'base'}) === 0;
    if(isBlockForeignCompany) {
      if(!isPathDashBoard) {
        urlRedirectUser()
      } else {
        return children;
      }
    } else {
      if(!isAllowedPage) {
        urlRedirectUser();
      } else if (futureRelease) {
        urlRedirectUser();
      } else {
        return children;
      }
    }
  };
  return <Route {...rest} render={renderContent}/>;
};
export default PrivateRoute;
